import { GlobalHeader } from 'components/_global/header/GlobalHeader';
import { BodyNoNav } from 'components/structure/body';
import { useBrowserContext } from 'contexts/BrowserContext';
import { ConsultProvider } from 'contexts/ConsultContext';
import { useCurrentUser } from 'contexts/CurrentUserContext';
import { useEnsureAuthenticated } from 'hooks/useEnsureAuthenticated';
import { Outlet, useParams } from 'react-router-dom';

export const ConsultLayout = () => {
  useEnsureAuthenticated();

  const { isMobileView } = useBrowserContext();
  const user = useCurrentUser();
  const { consultId } = useParams();

  return (
    <ConsultProvider consultId={consultId as string}>
      <GlobalHeader user={user.state.account} isMobileView={isMobileView} />
      <BodyNoNav>
        <Outlet />
      </BodyNoNav>
    </ConsultProvider>
  );
};
